// List of academic levels in Ghanaian universities
export const ghanaAcademicLevels = [
  // Undergraduate Levels
  "100 Level (First Year)",
  "200 Level (Second Year)",
  "300 Level (Third Year)",
  "400 Level (Fourth Year)",
  "500 Level (Fifth Year)",
  "600 Level (Sixth Year)",
  
  // Graduate Levels
  "Masters - First Year",
  "Masters - Second Year",
  "PhD - First Year",
  "PhD - Second Year",
  "PhD - Third Year",
  "PhD - Fourth Year",
  
  // Professional Levels
  "Diploma - First Year",
  "Diploma - Second Year",
  "Certificate Program",
  "Professional Certificate",
  "Post-Graduate Diploma",
  
  // Other Levels
  "Foundation Year",
  "Access Course",
  "Exchange Program",
  "Distance Learning",
  "Part-Time Program",
  "Evening Program",
  "Weekend Program"
];
